import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const MarketingBars = modules[vendor] ? modules[vendor] : modules["default"];

export default MarketingBars;
